// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"C_PH_TheComp__ID1TO"};